import { readStates } from '@/constants/lifecycle';
import findResult from '@/utils/resultsHelper';

const initialState = {
  pmnFunctions: {
    lookups: {
      results: [],
      ...readStates,
    },
    open: {
      results: [],
    },
  },
};

export const findPmnFunctions = ({ pmnFunctions }, { category }) => pmnFunctions[category];

export const findPmnFunction = ({ pmnFunctions }, { category, code }) => (
  findResult(pmnFunctions, category, code)
);

export default initialState;
